import './Info.css';
import React from 'react';
import Footer from '../UserPages/Footer';
import BGheader from '../Photoset/info-bg-header.svg';
import WhiteCircle from '../Photoset/white-circle.svg';
import BlueCircle from '../Photoset/blue-circle.svg';
import ImgHistory from '../Photoset/info-img-his.svg';

function Info() {

    return (
        <div>
            <div className='Info'>
                <section className='header-info'>
                    <div className='bg-header'><img src={BGheader}/></div>
                    <div className='header-text'>
                        <div className='left-h-t'>
                            <p>ประวัติความเป็นมา</p>
                        </div>
                        <div className='line-his-name'></div>
                        <div className='right-h-t'>
                            <h2>Our history</h2>
                        </div>
                    </div>
                    <div className='white-circle'>
                        <img src = {WhiteCircle}/>
                    </div>
                    <div className='blue-two-thirds-circle'>
                        <img src = {BlueCircle}/>
                    </div>
                </section>

                <section className='main-info'>
                    <div className='line'></div>
                    <div className='first-info'>
                        <div className='info-history'>
                            <div className='info-his-name'>
                                <h3>ประวัติของโรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัย</h3>
                            </div>
                            <div className='img-info'>
                                <img className='img-school' src= {ImgHistory}/>
                                <div className='info-each-line'>
                                    <p>ปี พ.ศ.๒๕๕๕ นายปรีชา โชคศิริเมฆากุล ซึ่งดำรงตำแหน่งนายกเทศมนตรีตำบลพยัคฆภูมิพิสัยในสมัยนั้น
                                        ได้จัดตั้งสถานศึกษาในเขตเทศบาลตำบลพยัคฆภูมิพิสัย ชื่อว่า“โรงเรียนเทศบาลอนุบาลตำบลพยัคฆภูมิพิสัย
                                        ณ บนที่ราชพัสดุแปลงที่ มค๓๔๓ บ้านเลขที่ ๑๐๐ หมู่ที่ ๑๖ บ้านสนามชัย ตำบลลานสะแก อำเภอพยัคฆภูมิพิสัย
                                        จังหวัด มหาสารคาม
                                    </p>
                                    <p>๒ ปีต่อมา ปี พ.ศ. ๒๕๕๗ นายอนวัช โชควรกุล นายกเทศมนตรีตำบลพยัคฆภูมิสัย ได้จัดตั้งการศึกษาเพื่อ
                                        บริการนักเรียนทั้งในเขตเทศบาลและนอกเขตเทศบาลในระดับที่สูงขึ้น จึงเสนอการขยายชั้นเรียน โรงเรียน
                                        อนุบาลเทศบาลตำบลพยัคฆภูมิพิสัยจากระดับอนุบาล ๑ - ๒ เป็นระดับอนุบาลจนถึงระดับชั้นประถมศึกษา
                                        ปีที่ ๖ เป็นต้นมา
                                    </p>
                                    <p>เมื่อวันที่ ๒๒ กรกฎาคม พ.ศ. ๒๕๕๘ นางสาวิตรี หงษ์ศรีแก้ว ตำแหน่ง หัวหน้าฝ่ายบริหารงานการศึกษา
                                        รักษาราชการแทนผู้อำนวยการสถานศึกษาในสมัยนั้นได้เสนอต่อที่ประชุมคณะกรรมการสถานศึกษาขั้นพื้นฐาน
                                        จนกระทั่ง วันที่ ๒ พฤศจิกายน พ.ศ. ๒๕๕๘ ได้เปลี่ยนชื่อโรงเรียนเป็น “โรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัย” นับแต่นั้นมา
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='info-vision'>
                            <div className='header-vision'>
                                <h3>วิสัยทัศน์ของเรา(Vision)</h3>
                            </div>
                            <div className='vision-line'></div>
                            <div className='text-Info'>
                                <p>โรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัย เป็นองค์กรแห่งการเรียนรู้ จัดการศึกษาได้ตามมาตรฐานการศึกษาชาติ</p>
                                <p>เป็นศูนย์กลางและต้นแบบทางด้านการจัดการศึกษา </p>
                                <p>มีความเป็นเลิศทาง ด้านวิชาการและคุณธรรม</p>
                            </div>
                        </div>
                        <div className='info-phi-mot'>
                            <div className='info-phi'>
                                <div className='header-phi'>
                                    <h3>ปรัชญา(philosophy)</h3>
                                </div>
                                <div className='phi-line'></div>
                                <div className='text-Info-pm'>
                                    <p>“สุวิชา โน ภวํ โหติ ผู้รู้ดีเป็นผู้เจริญ”</p>
                                </div>
                            </div>
                            <div className='info-mot'>
                                <div className='header-phi'>
                                    <h3>คำขวัญ(Motto)</h3>
                                </div>
                                <div className='mot-line'></div>
                                <div className='text-Info-pm'>
                                    <p>“เรียนดี  มีวินัย  ใฝ่คุณธรรม  น้อมนำเศรษฐกิจพอเพียง”</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='line'></div>
                    <div className='second-info'>
                        <div className='logo-left'>
                            <div className='img-logo'>
                                <img src="https://img5.pic.in.th/file/secure-sv1/436886651_428665596566104_8920613640456523024_n.png"/>
                            </div>
                            </div>
                        <div className='logo-right'>
                            <div className='header-logo'>
                                <h3>สัญลักษณ์ ความหมาย และสี</h3>
                            </div>
                            <div className='logo-line'></div>
                            <div className='logo-info'>
                                <div className='logo-info-l1'>
                                    <h3 className='text-on-logo'>สัญลักษณ์</h3>
                                    <h3 className='logo-mean' >“พญาเสือเปล่งรัศมีด้วยแสงแห่งคบเพลิง”</h3>
                                </div>
                                <div className='logo-info-l2'>
                                    <h3 className='text-on-logo'>เสือ หมายถึง</h3>
                                    <h3 className='tiger-mean' >ความน่าเกรงขาม ความเป็นผู้นำดั่ง โรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัยที่ต้องเป็นผู้นำทางการศึกษา</h3>
                                </div>
                                <div className='logo-info-l3'>
                                    <h3 className='text-on-logo'>คบเพลิง หมายถึง</h3>
                                    <h3 className='torch-mean'>แสงสว่างนำทางการศึกษา อันนำไปสู่ความเจริญรุ่งเรือง
                                        ดั่งเปลวไฟที่ส่องสว่างโชติช่วงชัชวาล</h3>
                                </div>
                                <div className='logo-info-l4'>
                                    <h3 className='text-on-logo'>อันเป็นหนึ่งเดียว</h3>
                                    <h3 className='all-mean'>โรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัยต้องเป็นผู้นำทางการศึกษา อันนำไปสู่ความสว่างไสว ความเจริญรุ่งเรืองของผู้เรียน
                                    </h3>
                                </div>
                                <div className='logo-info-l5'>
                                    <h3>สีประจำโรงเรียน</h3>
                                    <h3 className='school-color'>ฟ้า ขาว</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='line'></div>
                </section>

                
            </div>
            <div className='footer-info'><Footer /></div>
            
        </div >

    );

}

export default Info